import { Image, Text } from '@chakra-ui/react';
import { Form, FormikProps } from 'formik';
import React from 'react';

import { CoverPhotoValues } from './CoverPhoto.types';

/**
 * Note: This step has no real form, it is only there to serve for the StepperForm to work properly.
 */
export const CoverPhoto = React.forwardRef<
  HTMLFormElement,
  FormikProps<CoverPhotoValues>
>(({ handleSubmit }, ref) => {
  return (
    <>
      <Form onSubmit={handleSubmit} ref={ref}>
        <Text fontSize="md">
          Personalize your cover photo by simple selecting ‘Edit Cover Photo’
          and put a face to you name!
        </Text>
        <Text marginBottom={6} color="primary.300" fontSize="sm">
          (File type: PNG or JPEG - Recommended size: 1440px x 600px)
        </Text>
        <Image src="/images/mediaPackStepCoverPhoto.png" alt="Cover Photo" />
      </Form>
    </>
  );
});
